import create from "zustand";
import produce from "immer";

const STORE = {
  printPreference: {
    printMode: false,
    progress: true,
    rowAsList: false,
    sectionInNewPage: false,
    printTables: true,
    currentStepStatus: true,
    showCommentSection: true
  },
  mainComments: [],
  subComments: []
};

const createWithImmer = (storeCreator) =>
  create((originalSet, originalGet) =>
    storeCreator((fn) => originalSet(produce(fn)), originalGet)
  );

export const usePrintStore = createWithImmer((setState, getState) => ({
  ...STORE,
  setSectionInNewPage: (data) => {
    setState(() => {
      return { sectionInNewPage: data };
    });
  },
  setPrintPreference: (data) => {
    setState((state) => {
      return { printPreference: { ...state.printPreference, ...data } };
    });
  },
  setPrintMode: (data) => {
    setState(() => {
      return { printMode: data };
    });
  },
  setShowCommentSection: (data) => {
    setState(() => {
      return { showCommentSection: data };
    });
  },
  setUserComments: (data) => {
    setState((state) => {
      return {
        subComments: data.subComments,
        mainComments: data.mainComments
      };
    });
  }
}));
